function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0x9c96a0;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};

    var sprites;

    var counter;

    var itemsPositions = [{ x: 337, y: 15, n: "e_06" }, { x: 387, y: 35, n: "e_05" }, { x: 337, y: 196, n: "e_04" }, { x: 387, y: 216, n: "e_03" }, { x: 337, y: 377, n: "e_02" }, { x: 387, y: 397, n: "e_01" }, { x: 10, y: 79, n: "06" }, { x: 10, y: 79, n: "05" }, { x: 10, y: 79, n: "04" }, { x: 10, y: 79, n: "03" }, { x: 10, y: 79, n: "02" }, { x: 10, y: 79, n: "01" }];

    var biblio;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {
        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {
        gameData.numItems = 3;
        gameData.currentItem = 0;
        gameData.scene = biblio;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(335, 0);
        game.gameContainer.addChild(scenesContainer);

        biblio = new Scene('libri', itemsPositions);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 996;
        sprites.btn_gioca.y = 295;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;
    var Polygon = PIXI.Polygon;
    //
    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;
    var iterations = 0;
    var itemsMap = [{}, {}, {}, {}, {}, {}];

    var currentSequence;

    var bg = game.sprites.bg;
    container.addChild(bg);
    bg.position.set(322, 0);
    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);
    var polydx = new Polygon(0, 0, 60, 24, 60, 198, 0, 174);
    var polysx = new Polygon(0, 0, 49, 18, 49, 194, 0, 174);
    var itemPoly;
    for (var i = 0; i < positions.length; i++) {
        var pos = positions[i];



        var item = new PIXI.Graphics();
        // item.buttonMode = true;
        if (pos.n[0] === "e") {
            var posprefix = pos.n.split("_");
            switch (posprefix[1]) {
                case "01":
                case "03":
                case "05":

                    itemPoly = polydx;

                    break;
                default:

                    itemPoly = polysx;

                    break;
            }
            item.hitArea = itemPoly;
            item.name = posprefix[1];
            item.interactive = true;

            item.beginFill(0xff0000);
            item.drawPolygon(itemPoly);
            item.endFill();

            item.on('pointertap', onClick);
            item.buttonMode = true;
            var errIndex = parseInt(posprefix[1]) - 1;

            itemsMap[errIndex].error = item;
        } else {
            item = game.sprites[pos.n];
            item.name = pos.n;
            itemsMap[parseInt(pos.n) - 1].item = item;
        }

        item.position.set(pos.x, pos.y);

        container.addChild(item);

    }


    function clear() {


    }

    function reset() {
        itemsMap = _.shuffle(itemsMap);
        iterations = 0;

        for (var i = 0; i < itemsMap.length; i++) {
            var item = itemsMap[i].item;
            var err = itemsMap[i].error;
            item.alpha = 0;
            err.alpha = 0;
        }
        setState('newSequence');
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newSequence':
                itemsMap[0].item.alpha = 0;
                itemsMap.push(itemsMap.shift());
                currentSequence = itemsMap[0];
                currentSequence.item.alpha = 1;


                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {

        if (currentState === "ready") {
            var rightAnswer = currentSequence.item.name;
            var thisAnswer = this.name;
            var ok = currentSequence.error === this;


            if (ok) {

                renderer.view.dispatchEvent(new Event('answerOk'));
                iterations++;
                setTimeout(okComplete, 500);
                loopSequence = [renderAlways];
            } else {
                renderer.view.dispatchEvent(new Event('answerWrong'));
                tl.to(this, 0.20, { pixi: { alpha: 0.75 }, repeat: 3, yoyo: true }).addCallback(animationComplete, "+=1", [this]);
                loopSequence = [renderAlways];
                setState('animating');
            }


        }

    }

    function okComplete() {
        if (iterations < 3) {
            setState('newSequence');
        }

        theGame.cycleGame();
        loopSequence = [renderOnce];

    }

    function animationComplete(sprite) {
        sprite.alpha = 0;
        theGame.cycleGame();
        loopSequence = [renderOnce];
        setState('ready');
    }
}